import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { WAIT_FILT, WAIT_GET, WAIT_HISTO } from "./action-types";

// Obtenir les temps d'attente actuels
export function getWaitime({parcs, rides}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/waitime`;

        axios.post(url, {
            parcs: parcs,
            rides: rides
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: WAIT_GET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("wtge002");
                dispatch({
                    type: WAIT_GET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Obtenir l'historique des temps d'attente
export function getWaitimeHisto({
    parcs,
    rides,
    period,
    dates
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/waitime/histo`;

        axios.post(url, {
            parcs: parcs,
            rides: rides,
            period: period,
            dates: dates
        }, config) 
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: WAIT_HISTO,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("wahi002");
                dispatch({
                    type: WAIT_HISTO,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Obtentir les filtres de l'historique
export function getWaitimeFilters({
    parcs,
    period
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/waitime/filters`;

        axios.post(url, {
            parcs: parcs,
            period: period
        }, config) 
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: WAIT_FILT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("wafi002");
                dispatch({
                    type: WAIT_FILT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}